export const networksData = {
  Romania: [
    {
      name: 'Romanian Circular Economy Coalition (CERC)',
      countryRegion: 'Romania',
      mission: 'Circular economy',
      website: 'https://cerc.ro',
      contact: 'contact@cerc.ro'
    },
    {
      name: 'Romanian Association for Smart City (ARSC)',
      countryRegion: 'Romania',
      mission: 'Digital transition',
      website: 'https://romaniansmartcity.ro',
      contact: 'office@romaniansmartcity.ro'
    },
    {
      name: 'Women in Business Romania',
      countryRegion: 'Romania',
      mission: 'Women Enterprises',
      website: 'https://www.wib-romania.ro',
      contact: 'contact@wib-romania.ro'
    },
    {
      name: 'TechAngels Romania',
      countryRegion: 'Romania',
      mission: 'Digital transition',
      website: 'https://techangels.ro',
      contact: 'office@techangels.ro'
    }
  ],
  Moldova: [
    {
      name: 'European Business Association (EBA) Moldova',
      countryRegion: 'Moldova',
      mission: 'Circular economy',
      website: 'https://eboworldwide.eu/ebo-details/28',
      contact: 'info@eboworldwide.eu'
    },
    {
      name: 'Digital Innovation Hub of Moldova (DIH Moldova)',
      countryRegion: 'Moldova',
      mission: 'Digital transition',
      website:
        'https://aceti.md/en/aceti-has-produced-a-study-on-the-needs-for-digital-transformation-of-business-processes-in-the-regions/',
      contact: '373 69911744'
    },
    {
      name: 'Alliance for Women’s Economic Empowerment in the Republic of Moldova (AWEERM)',
      countryRegion: 'Moldova',
      mission: 'Women Enterprises',
      website: 'https://www.abilitare-economica.md/en/home-english-2/',
      contact: 'secretariat.abilitareeconomica@gmail.com'
    }
  ],
  Germany: [
    {
      name: 'Circular Economy Initiative Deutschland (CEID)',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://www.circular-economy-initiative.de',
      contact: 'info@circular-economy-initiative.de'
    },
    {
      name: 'PREVENT Waste Alliance',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://prevent-waste.net',
      contact: 'contact@prevent-waste.net'
    },
    {
      name: 'GreenTech BW (Umwelttechnik BW)',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://greentech-bw.de',
      contact: 'info@umwelttechnik-bw.de'
    },
    {
      name: 'Allianz für mehr Ressourceneffizienz BW',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://www.nachhaltigkeitsstrategie.de/wirtschaft/programme/ressourcen',
      contact: ''
    },
    {
      name: 'KEFF+ Resource Efficiency Network',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://www.keffplus-bw.de',
      contact: ''
    },
    {
      name: 'StartGreen',
      countryRegion: 'Germany',
      mission: 'Circular economy',
      website: 'https://start-green.net',
      contact: 'Borderstep Institute (info@borderstep.de)'
    },
    {
      name: 'Start-up BW Women',
      countryRegion: 'Germany',
      mission: 'Women Enterprises',
      website: 'https://startupbw.de/women',
      contact: ''
    }
  ],
  Croatia: [
    {
      name: 'Hrvatska gospodarska komora (HGK)',
      countryRegion: 'Croatia',
      mission: 'Digital transition',
      website: 'https://www.hgk.hr',
      contact: 'hgk@hgk.hr'
    },
    {
      name: 'Women in Adria',
      countryRegion: 'Croatia',
      mission: 'Women Enterprises',
      website: 'https://womeninadria.com',
      contact: 'info@womeninadria.com'
    },
    {
      name: 'Croatian Alliance for Circular Economy',
      countryRegion: 'Croatia',
      mission: 'Circular economy',
      website: 'https://www.hrvatskacirkularnaekonomija.hr',
      contact: 'info@hace.hr'
    },
    {
      name: 'Digital Croatia Initiative',
      countryRegion: 'Croatia',
      mission: 'Digital transition',
      website: 'https://digitalna.hr',
      contact: 'info@digitalna.hr'
    },
    {
      name: "Međunarodna mreža poslovnih žena - International Women's Business Network",
      countryRegion: 'Croatia',
      mission: 'Women Enterprises',
      website: 'https://mrezazena.com/',
      contact: 'mreza@mrezazena.com'
    }
  ],
  Austria: [
    {
      name: 'Female Founders',
      countryRegion: 'Austria',
      mission: 'Women Enterprises',
      website: 'https://www.female-founders.org/',
      contact: ''
    },
    {
      name: 'Frau in der Wirtschaft (FiW)',
      countryRegion: 'Austria',
      mission: 'Women Enterprises',
      website: 'https://www.wko.at/oe/fiw/start',
      contact: ''
    },
    {
      name: 'Circular Economy Forum Austria',
      countryRegion: 'Austria',
      mission: 'Circular economy',
      website: 'https://circulareconomyforum.at/en/',
      contact: ''
    },
    {
      name: 'respACT',
      countryRegion: 'Austria',
      mission: 'Circular economy',
      website: 'https://www.respact.at/',
      contact: ''
    },
    {
      name: 'Plattform Industrie 4.0',
      countryRegion: 'Austria',
      mission: 'Digital transition',
      website: 'https://plattformindustrie40.at/',
      contact: ''
    }
  ],
  Bulgaria: [
    {
      name: 'Bulgarian Chamber of Commerce and Industry',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://www.bcci.bg/',
      contact: 'n.dicheva@bcci.bg'
    },
    {
      name: 'Bulgarian Centre of Women in Technology',
      countryRegion: 'Bulgaria',
      mission: 'Digital transition',
      website: 'https://bcwt.bg/',
      contact: 'hello@bcwt.bg'
    },
    {
      name: 'Bulgarian Fund for Women',
      countryRegion: 'Bulgaria',
      mission: 'Women Enterprises',
      website: 'https://bgfundforwomen.org/en',
      contact: 'office@bgfundforwomen.org'
    },
    {
      name: 'The Council of Women in Business in Bulgaria',
      countryRegion: 'Bulgaria',
      mission: 'Women Enterprises',
      website: 'http://womeninbusiness.bg/',
      contact: 'office@womeninbusiness.bg'
    },
    {
      name: 'Center of women studies and policies',
      countryRegion: 'Bulgaria',
      mission: '',
      website: 'http://www.cwsp.bg/en/htmls/home.php',
      contact: 'cwsp@cwsp.bg'
    },
    {
      name: 'AgroHub',
      countryRegion: 'Bulgaria',
      mission: 'Digital transition',
      website: 'https://agrohub.bg/',
      contact: 'info@agrohub.bg'
    },
    {
      name: 'Association of Women Entrepreneurs in Bulgaria – Selena',
      countryRegion: 'Bulgaria',
      mission: 'Women Enterprises',
      website: 'https://selenabulgaria.com/bg/',
      contact: 'office@selenabulgaria.com'
    },
    {
      name: 'Sofia Development Association',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://sofia-da.eu',
      contact: 'office@sofia-da.eu'
    },
    {
      name: 'Bulgarian Association Circular Economy and Biotechnology BACEB',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website:
        'https://www.linkedin.com/in/bulgarian-association-circular-economy-and-biotech-baceb-a1b6131b0/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BcsGvPb%2FfSw2d75QTjrPXXA%3D%3D',
      contact: 'akibiot@gmail.com'
    },
    {
      name: 'Sustainability Specialists Association',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://www.ssa.bg/en/',
      contact: 'office@ssa.bg'
    },
    {
      name: 'Association for sustainable regional development',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://srd4bg.org/',
      contact: 'hello@srd4bg.org'
    },
    {
      name: 'Bulgarian Association for Sustainable Development',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'phone (+359) (89) 5512121',
      contact: 'phone (+359) (89) 5512121'
    },
    {
      name: 'Institute for Technology Transfer and Innovations',
      countryRegion: 'Bulgaria',
      mission: 'Digital transition',
      website: 'https://ittibg.org',
      contact: 'projectsitti@gmail.com'
    },
    {
      name: 'Institute for Entrepreneurship Sustainable Development and innovation',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://institute-esdi.org',
      contact: 'blacksea@institute-esdi.org'
    },
    {
      name: 'Institute for Circular Economy',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://iki.bg/',
      contact: 'office@iki.bg'
    },
    {
      name: 'National Ecological Institute',
      countryRegion: 'Bulgaria',
      mission: 'Circular economy',
      website: 'https://nei.bg/',
      contact: 'info@nei.bg'
    }
  ],
  Slovenia: [
    {
      name: 'Digital Innovation Hub Slovenia (DIH Slovenia)',
      countryRegion: 'Slovenia',
      mission: 'Digital transition',
      website: 'https://dihslovenia.si/en/about-us',
      contact: 'info@dihslovenia.si'
    },
    {
      name: 'EDIH Slovenia (European Digital Innovation Hub)',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'https://european-digital-innovation-hubs.ec.europa.eu/edih-catalogue/digital-innovation-hub-slovenia',
      contact: 'info@dihslovenia.si'
    },
    {
      name: 'ITC – Innovation Technology Cluster',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'https://itc-cluster.com/',
      contact: 'info@itc-cluster.com'
    },
    {
      name: 'DIH Agrifood',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'https://itc-cluster.com/',
      contact: 'info@itc-cluster.com'
    },
    {
      name: 'Automotive Cluster of Slovenia (ACS)',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'info@acs-giz.si',
      contact: 'info@acs-giz.si'
    },
    {
      name: 'Smart Factories Cluster Slovenia',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'https://dihslovenia.si',
      contact: 'info@dihslovenia.si'
    },
    {
      name: 'Wood Industry Cluster Slovenia',
      countryRegion: 'Slovenia',
      mission: 'Circular economy',
      website: 'https://dihslovenia.si',
      contact: 'info@dihslovenia.si'
    }
  ],
  Czechia: [
    {
      name: 'Business and Professional Women CR (BPW CR)',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://bpwcr.cz/',
      contact: 'bpwcr@bpwcr.cz'
    },
    {
      name: 'Association of Small and Medium-Sized Enterprises and Crafts CR – Women Entrepreneurship Platform',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.amsp.cz/',
      contact: 'amsp@amsp.cz'
    },
    {
      name: 'Czechitas',
      countryRegion: 'Czechia',
      mission: 'Digital transition',
      website: 'https://www.czechitas.cz/',
      contact: 'info@czechitas.cz'
    },
    {
      name: 'CzechInvest – Women Entrepreneurs Network',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://czechinvest.gov.cz/',
      contact: 'fdi@czechinvest.gov.cz'
    },
    {
      name: 'INCIEN',
      countryRegion: 'Czechia',
      mission: 'Circular economy',
      website: 'https://incien.org/',
      contact: ''
    },
    {
      name: 'Prague Circualar Hub',
      countryRegion: 'Czechia',
      mission: 'Circular economy',
      website:
        'https://circulareconomy.europa.eu/platform/en/dialogue/existing-eu-platforms/cirkularni-hub-praha-prague-circular-hub',
      contact: ''
    },
    {
      name: 'Czech Circualr Hotspot',
      countryRegion: 'Czechia',
      mission: 'Circular economy',
      website: 'https://incien.org/hotspot/',
      contact: 'veronika.borkova@incien.org'
    },
    {
      name: 'WEGate',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.wegate.eu/',
      contact: ''
    },
    {
      name: 'Holky z Byznysu',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.holkyzbyznysu.cz/',
      contact: 'ahoj@holkyzbyznysu.cz'
    },
    {
      name: 'Podnikání pro holky',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://podnikaniproholky.cz/',
      contact: 'info@podnikaniproholky.cz'
    },
    {
      name: 'Ženy v byznysu',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://zenyvbyznysu.cz/',
      contact: 'katerinatygl@gmail.com'
    },
    {
      name: 'Podnikatelky sobě',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.podnikatelkysobe.cz/',
      contact: 'info@podnikatelkysobe.cz'
    },
    {
      name: 'Spolek Podnikavé ženy z Pardubického kraje',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.podnikavezenypce.cz/',
      contact: 'info@podnikavezenypce.cz'
    },
    {
      name: 'Českomoravská asociace žen podnikatelek a manažerek',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.cmapm.cz/',
      contact: 'office@cmapm.cz'
    },
    {
      name: 'Ženy ze Severu',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.zenyzeseveru.cz/',
      contact: 'info@zenyzeseveru.cz'
    },
    {
      name: 'Vysočina Women',
      countryRegion: 'Czechia',
      mission: 'Women Enterprises',
      website: 'https://www.vysocinawomen.cz/',
      contact: 'info@vysocinawomen.cz'
    }
  ],
  'Slovak Republic': [
    {
      name: 'Union of Slovak Clusters (Únia klastrov Slovenska)',
      countryRegion: 'Slovakia',
      mission: 'Digital transition',
      website: 'https://uksk.sk/en/eca/?utm',
      contact: 'info@uksk.sk'
    },
    {
      name: 'Bioeconomy Cluster',
      countryRegion: 'Slovakia',
      mission: 'Circular economy',
      website: 'https://bioeconomy.sk/en/?utm',
      contact: 'info@bioeconomy.sk'
    },
    {
      name: 'Slovak Smart City Cluster',
      countryRegion: 'Slovakia',
      mission: 'Digital transition',
      website: 'https://smartcluster.sk/en/?utm',
      contact: 'ssccc@smartcluster.sk'
    },
    {
      name: 'Circular Slovakia (Circular Economy Platform)',
      countryRegion: 'Slovakia',
      mission: 'Circular economy',
      website: 'https://circular-slovakia.sk/en/?utm',
      contact: 'https://circular-slovakia.sk/en/kontakt/'
    },
    {
      name: 'EDIH CASSOVIUM (European Digital Innovation Hub)',
      countryRegion: 'Slovakia',
      mission: 'Digital transition',
      website: 'https://edihcassovium.sk/en/?utm',
      contact: 'info@edihcassovium.sk'
    },
    {
      name: 'SKAI‑eDIH (Slovak Artificial Intelligence Digital Innovation Hub)',
      countryRegion: 'Slovakia',
      mission: 'Digital transition',
      website: 'https://european-digital-innovation-hubs.ec.europa.eu/sk/node/268?utm',
      contact: 'info@hopero.sk'
    },
    {
      name: 'EXPANDI 4.0 (EDIH)',
      countryRegion: 'Slovakia',
      mission: 'Digital transition',
      website: 'https://www.expandi40.sk/',
      contact: 'info@expandi40.sk'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      name: 'WE.Circular (Interreg Danube Region project)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Women Enterprises',
      website: 'https://danube-region.eu/we-circular/ (EUSDR - Danube Strategy Point)',
      contact: 'Via lead partners / project contact listed on website'
    },
    {
      name: 'Foreign Trade Chamber of Bosnia and Herzegovina – Green & Circular Economy Stakeholder Platform',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Women Enterprises',
      website: 'https://wbcirculareconomy.com/ (Western Balkans Circular Economy Hub)',
      contact: 'info@komorabih.ba (typical for chamber)'
    },
    {
      name: 'Udruženje poslovnih žena u BiH (Association of Business Women in BiH)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Women Enterprises',
      website: 'https://poduzetna.ba/ (Poduzetna)',
      contact: 'Through website contact form'
    },
    {
      name: 'SEDEP – Digital and Green Society Program',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://digigreen.ba/en/ (DigiGreen)',
      contact: 'Contact via website'
    },
    {
      name: 'eComm Asocijacija Bosne i Hercegovine (E-commerce Association BiH)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://poduzetna.ba/* eComm info (portal page referencing) (Poduzetna)',
      contact: 'Through association contacts on site'
    },
    {
      name: 'UNDP Green Transition Partnership Platform',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Circular economy',
      website:
        'https://www.undp.org/bosnia-herzegovina/press-releases/advancing-circular-economy-bosnia-and-herzegovina-towards-green-transition-and-sustainable-future (UNDP)',
      contact: 'UNDP BiH office (registry.ba@undp.org)'
    },
    {
      name: '“Žene i točka” (Women and Point) business community',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Women Enterprises',
      website: 'https://poduzetna.ba/ (Poduzetna)',
      contact: 'Through portal contacts'
    },
    {
      name: 'GFEB (Green Transition of Women Entrepreneurs – regional support initiative)*',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Circular economy',
      website: 'Referenced via Udruženje poslovnih žena BiH (Poduzetna)',
      contact: 'Via Udruženje poslovnih žena'
    },
    {
      name: 'Digital Storm HUB',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://digitalstorm.ba/ (Digital Storm)',
      contact: 'Via website / info@digitalstorm.ba'
    },
    {
      name: 'IDEMO Digital Innovation Hub',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://dihidemo.org/ (iDEMO)',
      contact: 'Contact via site'
    },
    {
      name: 'Industrial HUB (Tuzla)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://eu4digitalsme.ba/en/digital-innovation-hub/industrial-hub/ (EU4 Digital SME)',
      contact: 'Via project contacts'
    },
    {
      name: 'Its4Health HUB (Sarajevo)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'Local DIH listed under EU4DigitalSME initiatives (Federalna)',
      contact: 'Via project contacts'
    },
    {
      name: 'LabHub – Sarajevo Digital Innovation Hub',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://labhub.ba/ (Labhub)',
      contact: 'Via website'
    },
    {
      name: 'Digital Innovation Hub ONEX',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://onex.digital/en/edih (European Digital Innovation Hubs Network)',
      contact: 'info@onex.digital'
    },
    {
      name: 'EU4DigitalSME Network (ecosystem project)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://eu4digitalsme.ba/ (EU4 Digital SME)',
      contact: 'Via project info'
    },
    {
      name: 'DIH Forum / DIH Community Platform',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website:
        'https://digigreen.ba/en/dih-forum-2025-supporting-the-development-of-sustainable-and-digitally-empowered-small-and-medium-sized-enterprises/ (DigiGreen)',
      contact: 'Via initiative contact'
    },
    {
      name: 'FusionX Hub (DIH)',
      countryRegion: 'Bosnia and Herzegovina',
      mission: 'Digital transition',
      website: 'https://fusionxhub.com/ (fusionxhub.com)',
      contact: 'Contact via website (contact form) (fusionxhub.com)'
    }
  ],
  Serbia: [
    {
      name: 'Digital Platform Circular Economy Serbia',
      countryRegion: 'Serbia',
      mission: 'Circular economy',
      website:
        'https://circulareconomy.europa.eu/platform/en/dialogue/existing-eu-platforms/digital-platform‑circular‑economy‑serbia',
      contact: 'kabinet@pks.rs'
    },
    {
      name: 'Serbian European Digital Innovation Hub (S4AI Hub)',
      countryRegion: 'Serbia',
      mission: 'Digital transition',
      website: 'https://s4ai.rs/en/who-we-are/',
      contact: 'info@icthub.rs'
    },
    {
      name: 'Enterprise Innovation Network – EEN Serbia',
      countryRegion: 'Serbia',
      mission: 'Women Enterprises',
      website: 'https://een.ec.europa.eu/',
      contact: 'info@een.ec.europa.eu'
    },
    {
      name: 'Chamber of Commerce Serbia – Circular and Sustainable Business Working Groups',
      countryRegion: 'Serbia',
      mission: 'https://pks.rs/en/',
      website: 'Circular economy',
      contact: 'contact@centercecc.org'
    }
  ],
  Hungary: [
    {
      name: 'SEED Kisvállalkozás-fejlesztési Alapítvány',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'seed.hu',
      contact: 'seed@seed.hu'
    },
    {
      name: 'Magyar Női Unió',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://www.mnunio.hu/rolunk',
      contact: 'info@mnunio.hu'
    },
    {
      name: 'Budapesti Kereskedelmi és Iparkamara – Női Vállalkozói Klub',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'bkik.hu',
      contact: 'ugyfelszolgalat@bkik.hu'
    },
    {
      name: 'Design Terminal – Női Vállalkozói Programok',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'designterminal.org',
      contact: 'https://fidtq.share-eu1.hsforms.com/2uK3Zf4TIQregn89jEnLR0Q'
    },
    {
      name: 'Női Vállalkozói Klub (NVK)',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'noivallalkozok.hu',
      contact: 'simon.erika@noivallalkozok.hu'
    },
    {
      name: 'VOSZ – Vállalkozók és Munkáltatók Országos Szövetsége',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'vosz.hu',
      contact: 'ugyfelszolgalat@vosz.hu'
    },
    {
      name: 'Impact Hub Budapest',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'budapest.impacthub.net',
      contact: 'budapest@impacthub.net'
    },
    {
      name: 'AWE Hungary – Academy for Women Entrepreneurs',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'awehungary.com',
      contact: ''
    },
    {
      name: 'Magyar Női Karrierfejlesztési Szövetség',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'noikarrier.hu',
      contact: 'info@noikarrier.hu'
    },
    {
      name: 'Hétfa Kutatóintézet',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'hetfa.hu',
      contact: 'info@hetfa.hu'
    },
    {
      name: 'Magyar Női Érdekérvényesítő Szövetség',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://www.noierdek.hu/',
      contact: 'noierdek@gmail.com'
    },
    {
      name: 'Nők a neten',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://nokaneten.hu/rolunk/utasi-melinda/',
      contact: 'https://nokaneten.hu/kapcsolat/'
    },
    {
      name: 'Women in Technology Hungary (WiTH)',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'with.hu',
      contact: 'https://domain2.hu/contact'
    },
    {
      name: 'IVSZ – Digitális Vállalkozások Szövetsége',
      countryRegion: 'Hungary',
      mission: 'Digital transition',
      website: 'ivsz.hu',
      contact: 'iroda@ivsz.hu'
    },
    {
      name: 'Neumann Technológiai Platform',
      countryRegion: 'Hungary',
      mission: 'Digital transition',
      website: 'neum.hu',
      contact: 'info@neum.hu'
    },
    {
      name: 'Women in AI Hungary',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'womeninai.co',
      contact: ''
    },
    {
      name: 'Women in Technology Association Hungary',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://nokatud.hu/',
      contact: 'hello@nokatud.hu'
    },
    {
      name: 'Academy for Women Entrepreneurs (AWE) Hungary',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://awehungary.com/en/home/',
      contact: 'info@awehungary.com'
    },
    {
      name: 'Enterprise Europe Network Hungary',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'https://een.ec.europa.eu/',
      contact: 'eeninfo@hepa.hu'
    },
    {
      name: 'Hungarian Chamber of Commerce and Industry (MKIK)',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://mkik.hu/',
      contact: 'mkik@mkik.hu'
    },
    {
      name: 'Startup Hungary Foundation',
      countryRegion: 'Hungary',
      mission: 'Women Enterprises',
      website: 'https://startuphungary.io/',
      contact: 'hello@startuphungary.io'
    },
    {
      name: 'BCSDH Circular Economy Platform',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'bcsdh.hu',
      contact: 'ivett.takacs@bcsdh.hu'
    },
    {
      name: 'Magyar Természetvédők Szövetsége',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'mtvsz.hu',
      contact: 'info@mtvsz.hu'
    },
    {
      name: 'KSZGYSZ (Env. Enterprises)',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'kszgysz.hu',
      contact: 'kszgysz@kszgysz.hu'
    },
    {
      name: 'Circular Point (Geonardo)',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'circularpoint.eu',
      contact: 'info@circularpoint.eu'
    },
    {
      name: 'HOSZ (Waste Federation)',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'hosz.org',
      contact: 'info@hosz.org'
    },
    {
      name: 'HuGBC (Hungary Green Building Council)',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'hugbc.hu',
      contact: 'https://www.hugbc.hu/kapcsolat'
    },
    {
      name: 'KGTP (Circular Economy Technology Platform)',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'nkfih.gov.hu',
      contact: 'nkfihivatal@nkfih.gov.hu'
    },
    {
      name: 'Bay Zoltán Research',
      countryRegion: 'Hungary',
      mission: 'Circular Economy',
      website: 'bayzoltan.hu',
      contact: 'bayzoltan@bayzoltan.hu'
    }
  ]
}
